import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { ContractFilter } from '../../../entities'
import { getAllContracts } from '../../contracts'

export default function useContracts(query: PaginatedRequest<ContractFilter>) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['opportunities', query],
    () => getAllContracts(query),
    {
      keepPreviousData: true
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
